import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { estEspaceOrganisateur } from "../espace";

//! ===Admin Tacki

// Dashboard
import DashboardAdmin from "../pages/Admin-Takci/Dashboard";

// Client
import Client from "../pages/Admin-Takci/Clients/index";
import ClientsDetail from "../pages/Admin-Takci/Clients/detail";
// Details activité
// import ClientActivityHistory from "../pages/Admin-Takci/Clients/activityHistory";

// Admin
import Admin from "../pages/Admin-Takci/Admins/index";

// Chauffeur
import Chauffeur from "../pages/Admin-Takci/Chauffeurs/index";
import ChauffeurEnAttente from "../pages/Admin-Takci/Chauffeurs/attente";
// import ChauffeursDetail from "../pages/Admin-Takci/Chauffeurs/detail1";
import ChauffeursDetail from "../pages/Admin-Takci/Chauffeurs/detail";
// Details activité
import DriverActivityHistory from "../pages/Admin-Takci/Chauffeurs/activityHistory";

// Livreur
import Livreur from "../pages/Admin-Takci/Livreurs/index";
import LivreurEnAttente from "../pages/Admin-Takci/Livreurs/attente";
import LivreursDetail from "../pages/Admin-Takci/Livreurs/detail";
import LivreurActivityHistory from "../pages/Admin-Takci/Livreurs/activityHistory";

// Courses
import HistoriqueCourses from "../pages/Admin-Takci/Courses/index";
import CoursesAttente from "../pages/Admin-Takci/Courses/attente";
import CoursesAnnulees from "../pages/Admin-Takci/Courses/annulees";

// Livraisons
import HistoriqueLivraisons from "../pages/Admin-Takci/Livraisons/index";
import LivraisonsAttente from "../pages/Admin-Takci/Livraisons/attente";
import LivraisonsAnnulees from "../pages/Admin-Takci/Livraisons/annulees";

//------------Billeterie

// Organisateurs
import Organisateurs from "../pages/Admin-Takci/Billeterie/Organisateurs/organisateurs";
import OrganizerActivityHistory from "../pages/Admin-Takci/Billeterie/Organisateurs/activityHistory";
import OrganisateurPay from "../pages/Admin-Takci/Billeterie/Organisateurs/organisateurs-paie";
import OrganisateurAskPay from "../pages/Admin-Takci/Billeterie/Organisateurs/organisateurs-demande-paie";

// Evenements
import CalendarEvent from "../pages/Admin-Takci/Billeterie/Event/index";
import EventActivityHistory from "../pages/Admin-Takci/Billeterie/Event/activityHistory";

// User Profile
import UserProfile from "../pages/Admin-Takci/Profile/Profil-admin";

// Finances
import Finances from "../pages/Admin-Takci/Finances";

// Code Promo
import CodePromo from "../pages/Admin-Takci/CodePromos";
import UserCodePromo from "../pages/Admin-Takci/CodePromos/UserCodePromo";

// Parainage
import Parainage from "../pages/Admin-Takci/Parainage";
import Filleuls from "../pages/Admin-Takci/Parainage/filleuls";
// Plan
import MapComponent from "../pages/Admin-Takci/Plan";
// Messagerie
import Alertes from "../pages/Admin-Takci/Alertes";

// Historique des activités
import HistoriqueActivity from "../pages/Admin-Takci/History-Activity";

//! ===Admin Tacki

//!===Organisateur Tacki

// Dashboard
//  "/src/Organisateurs-Takci/";

// Finances Organisateur
import FinancesOrganizer from "../pages/Admin-Takci/Finances/index-organizer";

//!===Organisateur Tacki

//Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";

//Maps
import VectorMaps from "../pages/Maps/VectorMaps/VectorMaps";
import LeafletMaps from "../pages/Maps/LeafletMaps/LeafletMaps";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import DriverAdd from "../pages/Admin-Takci/Chauffeurs/DriverAdd";
import LivreurAdd from "../pages/Admin-Takci/Livreurs/LivreurAdd";
import Facturation from "../pages/Admin-Takci/Facturation/tarifs";
import TypeEngin from "../pages/Admin-Takci/Facturation/index";

import Majoration from "../pages/Admin-Takci/Majoration";

import LogoutOrganizer from "../pages/Authentication-Organizer/Logout";
import LoginOrganizer from "../pages/Authentication-Organizer/Login";
import ForgetPasswordOrganizerPage from "../pages/Authentication-Organizer/ForgetPassword";
import RegisterOrganizer from "../pages/Authentication-Organizer/Register";
import AjouterEvenement from "../pages/Admin-Takci/Billeterie/Event/AjouterEvenement";
import Security from "../pages/Admin-Takci/Security";
import AgentDetail from "../pages/Admin-Takci/Security/detailAgent";
import BilletDetail from "../pages/Admin-Takci/Billeterie/Event/BilletDetail";
import Remboursements from "../pages/Admin-Takci/Remboursements";
import RemboursementsAdd from "../pages/Admin-Takci/Remboursements/RemboursementsAdd";
import RemboursementsDetail from "../pages/Admin-Takci/Remboursements/RemboursementsDetail";
import ParametreRemboursement from "../pages/Admin-Takci/Remboursements/ParametreRemboursement";
import Plans from "../pages/Admin-Takci/Plans";
import PlansDetail from "../pages/Admin-Takci/Plans/PlansDetail";
import AllRemboursement from "../pages/Admin-Takci/Plans/AllRemboursement";
import RemboursementsDetails from "../pages/Admin-Takci/Plans/RemboursementsDetails";

function useAuthProtectedRoutes() {
  const [roleSession, setRoleSession] = useState("");
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  const adminRoutes = [
    // Dashboard
    { path: "/dashboard", component: DashboardAdmin },

    // Client
    { path: "/client", component: Client },
    { path: "/client/:id", component: ClientsDetail },
    // { path: "/client-activity/:id", component: ClientActivityHistory },

    // Admin
    { path: "/admin", component: Admin },
    //Historique des activités
    {
      path: "/admin/activity/:user_id",
      component: HistoriqueActivity,
    },

    // User Profile
    { path: "/profile", component: UserProfile },

    // Chauffeur
    { path: "/chauffeur", component: Chauffeur },
    { path: "/chauffeur/add", component: DriverAdd },
    { path: "/chauffeur-en-attente", component: ChauffeurEnAttente },
    { path: "/chauffeur/:id", component: DriverActivityHistory },
    { path: "/chauffeur-detail/:id", component: ChauffeursDetail },

    // Livreur
    { path: "/livreur", component: Livreur },
    { path: "/livreur/add", component: LivreurAdd },
    { path: "/livreur-en-attente", component: LivreurEnAttente },
    { path: "/livreur/:id", component: LivreurActivityHistory },
    { path: "/livreur-detail/:id", component: LivreursDetail },

    // Courses
    { path: "/courses", component: HistoriqueCourses },
    { path: "/courses-attente", component: CoursesAttente },
    { path: "/courses-attente/:id", component: CoursesAttente },
    { path: "/courses-annulee", component: CoursesAnnulees },

    // Livraisons
    { path: "/livraisons", component: HistoriqueLivraisons },
    { path: "/livraisons-attente", component: LivraisonsAttente },
    { path: "/livraisons-attente/:id", component: LivraisonsAttente },
    { path: "/livraisons-annulee", component: LivraisonsAnnulees },

    // ------------Billeterie
    // Organisateurs
    { path: "/organisateurs", component: Organisateurs },
    { path: "/organisateurs/:id", component: OrganizerActivityHistory },
    { path: "/organisateurs-paid", component: OrganisateurPay },
    { path: "/organisateurs-ask-pay", component: OrganisateurAskPay },

    // Evenements
    { path: "/evenements", component: CalendarEvent },
    { path: "/evenements/:id", component: EventActivityHistory },

    // Evenements
    { path: "/code-promo", component: CodePromo },
    { path: "/code-promo/id", component: UserCodePromo },

    // Parainages
    { path: "/parainage", component: Parainage },
    { path: "/parainage/:code_parrainage", component: Filleuls },

    // Finances
    { path: "/finances", component: Finances },
    // Plan
    { path: "/plan", component: MapComponent },
    // Alertes
    { path: "/alertes", component: Alertes },

    // Remboursements
    { path: "/remboursements", component: Remboursements },
    { path: "/remboursements/add", component: RemboursementsAdd },
    { path: "/remboursements-detail/:id", component: RemboursementsDetail },
    { path: "/parametres-remboursements", component: ParametreRemboursement },

    //Plans de Remboursement
    { path: "/plans", component: Plans },
    { path: "/plans-detail/:id", component: PlansDetail },
    { path: "/allremboursements", component: AllRemboursement },
    { path: "/remboursement-detail/:conducteur_id", component: RemboursementsDetails },
    
    // Facture
    { path: "/facturation", component: Facturation },
    { path: "/type-engin", component: TypeEngin },

    { path: "/majoration-courses", component: Majoration },

    //!-------------

    //Icons
    { path: "/icons-remix", component: RemixIcons },
    { path: "/icons-boxicons", component: BoxIcons },
    { path: "/icons-materialdesign", component: MaterialDesign },
    { path: "/icons-feather", component: FeatherIcons },
    { path: "/icons-lineawesome", component: LineAwesomeIcons },

    //Maps
    { path: "/maps-vector", component: VectorMaps },
    { path: "/maps-leaflet", component: LeafletMaps },

    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name

    // !
    {
      path: "/",
      exact: true,
      component: () => <Redirect to="/dashboard" />,
    },
    {
      path: "*",
      exact: true,
      component: () => <Redirect to="/dashboard" />,
    },
    // { path: "*", component: UserProfile },
  ];

  /**
   * Écrans ouverts à un organisateur : ceux de son menu, plus le tableau de
   * bord, son profil et les codes promo de ses événements.
   *
   * Le tableau ci-dessous était presque identique à celui de l'administrateur
   * — 54 entrées contre 60. Les écrans absents du menu restaient atteignables
   * en tapant l'URL : chauffeurs, courses, liste des autres organisateurs,
   * activité des administrateurs.
   */
  const CHEMINS_ORGANISATEUR = [
    "/dashboard",
    "/profile",
    "/evenements",
    "/organisateurs-paid",
    "/organisateurs-ask-pay",
    "/finances",
    "/security",
    "/alertes",
    "/code-promo",
  ];

  const ouvertAOrganisateur = (chemin) =>
    chemin === "/" ||
    chemin === "*" ||
    CHEMINS_ORGANISATEUR.some(
      (base) => chemin === base || chemin.startsWith(base + "/"),
    );

  const organizerRoutes = [
    // Dashboard
    { path: "/dashboard", component: DashboardAdmin },

    // Codes promo de ses propres événements
    { path: "/code-promo", component: CodePromo },

    // Evenements
    { path: "/evenements", component: CalendarEvent },
    { path: "/evenements/add", component: AjouterEvenement },
    { path: "/evenements/add/:id/", component: AjouterEvenement },
    { path: "/evenements/:id", component: EventActivityHistory },
    { path: "/evenements/billets/:id", component: BilletDetail },
    // AjouterEvenement

    // Sécurité
    { path: "/security", component: Security },
    { path: "/security/:id", component: AgentDetail },

    // Client
    { path: "/client", component: Client },
    { path: "/client/:id", component: ClientsDetail },
    // secure
    // { path: "/client-activity/:id", component: ClientActivityHistory },

    // Admin
    { path: "/admin", component: Admin },
    //Historique des activités
    {
      path: "/admin/activity/:user_id",
      component: HistoriqueActivity,
    },

    // User Profile
    { path: "/profile", component: UserProfile },

    // Chauffeur
    { path: "/chauffeur", component: Chauffeur },
    { path: "/chauffeur/add", component: DriverAdd },
    { path: "/chauffeur-en-attente", component: ChauffeurEnAttente },
    { path: "/chauffeur/:id", component: DriverActivityHistory },
    { path: "/chauffeur-detail/:id", component: ChauffeursDetail },

    // Livreur
    { path: "/livreur", component: Livreur },
    { path: "/livreur/add", component: LivreurAdd },
    { path: "/livreur-en-attente", component: LivreurEnAttente },
    { path: "/livreur/:id", component: LivreurActivityHistory },
    { path: "/livreur-detail/:id", component: LivreursDetail },

    // Courses
    { path: "/courses", component: HistoriqueCourses },
    { path: "/courses-attente", component: CoursesAttente },
    { path: "/courses-attente/:id", component: CoursesAttente },
    { path: "/courses-annulee", component: CoursesAnnulees },

    // Livraisons
    { path: "/livraisons", component: HistoriqueLivraisons },
    { path: "/livraisons-attente", component: LivraisonsAttente },
    { path: "/livraisons-attente/:id", component: LivraisonsAttente },
    { path: "/livraisons-annulee", component: LivraisonsAnnulees },

    // ------------Billeterie
    // Organisateurs
    { path: "/organisateurs", component: Organisateurs },
    { path: "/organisateurs/:id", component: OrganizerActivityHistory },
    { path: "/organisateurs-paid", component: OrganisateurPay },
    { path: "/organisateurs-ask-pay", component: OrganisateurAskPay },

    // Parainages
    { path: "/parainage", component: Parainage },
    { path: "/parainage/:code_parrainage", component: Filleuls },

    // Finances
    { path: "/finances", component: FinancesOrganizer },
    // Plan
    { path: "/plan", component: MapComponent },
    // Alertes
    { path: "/alertes", component: Alertes },

    // Facture
    { path: "/facturation", component: Facturation },
    { path: "/majoration-courses", component: Majoration },

    //!-------------

    //Icons
    { path: "/icons-remix", component: RemixIcons },
    { path: "/icons-boxicons", component: BoxIcons },
    { path: "/icons-materialdesign", component: MaterialDesign },
    { path: "/icons-feather", component: FeatherIcons },
    { path: "/icons-lineawesome", component: LineAwesomeIcons },

    //Maps
    { path: "/maps-vector", component: VectorMaps },
    { path: "/maps-leaflet", component: LeafletMaps },

    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name

    // !
    {
      path: "/",
      exact: true,
      component: () => <Redirect to="/dashboard" />,
    },
    {
      path: "*",
      exact: true,
      component: () => <Redirect to="/dashboard" />,
    },
    // { path: "*", component: UserProfile },
  ];

  function getSessionData() {
    const authUser = localStorage.getItem("authUser");

    // Dans l'espace organisateur, aucun jeu de routes administrateur n'est
    // construit, quel que soit le rôle de la session : le build ne sert que
    // cet espace. Le filtre par rôle reste en place dans l'administration,
    // en attendant que plus aucun organisateur n'y accède.
    let userRoutes = estEspaceOrganisateur
      ? organizerRoutes.filter((r) => ouvertAOrganisateur(r.path))
      : adminRoutes;

    if (authUser) {
      const obj = JSON.parse(authUser);
      setRoleSession(obj.role);

      if (!estEspaceOrganisateur && obj.role === "ORGANISATEUR") {
        userRoutes = organizerRoutes.filter((r) =>
          ouvertAOrganisateur(r.path),
        );
      }
    }

    setRoutes(userRoutes);
    setLoading(false);
  }

  useEffect(() => {
    getSessionData();
  }, []);

  return { authProtectedRoutes: routes, loading, roleSession };
}

const routesAdmin = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPasswordPage },
  { path: "/forgot-password/:tokenParam", component: ForgetPasswordPage },
  { path: "/register", component: Register },
];

const routesOrganisateur = [
  { path: "/logout-organizer", component: LogoutOrganizer },
  {
    path: "/login-organizer",
    component: LoginOrganizer,
  },
  {
    path: "/forgot-password-organizer",
    component: ForgetPasswordOrganizerPage,
  },
  {
    path: "/forgot-password-organizer/:tokenParam",
    component: ForgetPasswordOrganizerPage,
  },
  { path: "/register-organizer", component: RegisterOrganizer },
];

// Un build ne sert que les écrans d'accès de son espace : l'administration
// n'expose pas l'inscription des organisateurs, et l'espace organisateur
// n'expose pas la connexion de l'administration.
const publicRoutes = estEspaceOrganisateur ? routesOrganisateur : routesAdmin;

export { useAuthProtectedRoutes, publicRoutes };
